import { getContentUrl } from "../../StaticAssets";
import * as StaticConfig from "../../StaticConfig";
import { TableauLocalizedStrings } from "../../Strings";

export function showPublicErrorPage(
  doc: Document,
  strings: TableauLocalizedStrings
) {
  const renderer = new PublicErrorPageRenderer(doc, strings);
  doc.body.replaceChildren(...renderer.topPageElements());
}

class PublicErrorPageRenderer {
  doc: Document;
  strings: TableauLocalizedStrings;
  publicGalleryUrl: string;

  constructor(doc: Document, strings: TableauLocalizedStrings) {
    this.doc = doc;
    this.strings = strings;
    this.publicGalleryUrl =
      StaticConfig.publicGalleryLink(this.doc) ||
      "https://public.tableau.com/s/gallery";
  }

  public topPageElements(): HTMLElement[] {
    return [
      this.whereViz(),
      this.br(),
      this.explanation(),
      this.br(),
      this.br(),
      this.browseGallery(),
      this.inspiration(),
    ];
  }

  private br() {
    return this.doc.createElement("br");
  }

  private textInsideTable() {
    const p = this.doc.createElement("p");
    p.className = "Textinsidetable";
    return p;
  }

  private whereViz() {
    const p = this.textInsideTable();
    p.style.fontSize = "18px";
    p.textContent = this.strings.getString("ShowPageErrorPublicWhereViz");
    return p;
  }

  private explanation() {
    const p = this.textInsideTable();
    p.innerHTML = this.strings.getString("ShowPageErrorPublicContentNotFound");
    return p;
  }

  private browseGallery() {
    const p = this.textInsideTable();
    p.innerHTML = this.strings.PublicErrorBrowseGallery(this.publicGalleryUrl);
    return p;
  }

  private inspiration() {
    const inspiration = this.doc.createElement("div");
    inspiration.id = "inspiration";
    inspiration.style.textAlign = "left";

    inspiration.appendChild(this.table());
    return inspiration;
  }

  private table() {
    const table = this.doc.createElement("table");
    // These are theoretically deprecated, but currently supported in every browser
    // and are in use accross the Tableau codebase.
    // Moving Gallery table styling to a stylesheet will have to be done by the Public team.
    table.cellPadding = "0";
    table.cellSpacing = "0";
    table.border = "0";
    table.width = "100%";
    const singleRow = table.insertRow();
    singleRow.insertCell().appendChild(this.clearImageWithWidth(24));

    const galleryImageCell = singleRow.insertCell();
    galleryImageCell.style.position = "relative";
    galleryImageCell.width = "100%";
    galleryImageCell.appendChild(this.galleryImageContainer());

    singleRow.insertCell().appendChild(this.clearImageWithWidth(4));
    return table;
  }

  private clearImageWithWidth(width: number) {
    const img = this.doc.createElement("img");
    img.src = getContentUrl("/images/clear.gif");
    img.alt = "Clear";
    img.width = width;
    img.height = 1;
    return img;
  }

  private galleryImageContainer() {
    const topDiv = this.doc.createElement("div");
    topDiv.style.position = "relative";

    const secondDiv = this.doc.createElement("div");
    secondDiv.style.position = "absolute";
    secondDiv.style.left = "0px";
    secondDiv.style.top = "0px";
    secondDiv.style.width = "100%";

    const thirdDiv = this.doc.createElement("div");
    thirdDiv.style.paddingRight = "20px";

    const imgTitle = this.doc.createElement("p");
    imgTitle.className = "imgTitle";

    const anchor = this.doc.createElement("a");
    anchor.className = "img";
    anchor.href = this.publicGalleryUrl;

    anchor.appendChild(this.galleryImage());
    anchor.appendChild(this.br());
    imgTitle.appendChild(anchor);
    thirdDiv.appendChild(imgTitle);
    secondDiv.appendChild(thirdDiv);
    topDiv.appendChild(secondDiv);
    return topDiv;
  }

  private galleryImage() {
    const galleryImage = this.doc.createElement("img");
    galleryImage.src = getContentUrl("/images/404_gallery.png");
    galleryImage.id = "galleryImage";
    galleryImage.className = "autoSizeImage";
    galleryImage.alt = "Sample Gallery";
    galleryImage.style.maxHeight = "100px";
    galleryImage.style.maxWidth = "545px";
    return galleryImage;
  }
}
